// extracted by mini-css-extract-plugin
module.exports = {"logo-wrapper":"dlj3X"};